import SrDuration from "./index.vue";

SrDuration.install = function(Vue) {
  Vue.component(SrDuration.name, SrDuration);
};

export default SrDuration;



// WEBPACK FOOTER //
// ./packages/SrDuration/index.js